import { gql } from '@apollo/client';

export const InPersonAddressFragment = gql`
  fragment InPersonAddressFragment on EventVenue_InPersonLocation_Address {
    administrativeArea
    country
    locality
    name
    postalCode
    streetAddress
    streetAddressLine2
  }
`;

export const VideoFileFragment = gql`
  fragment VideoFileFragment on VideoFile {
    _id
    filename
    hlsVideoStreamUrl
    s3DownloadUrl
    thumbnailImageUrl
  }
`;

export const VirtualEventArchiveFragment = gql`
  fragment VirtualEventArchiveFragment on VirtualEventArchive {
    _id
    videoFile {
      ...VideoFileFragment
    }
    videoFileId
  }
`;

export const SessionInfoFragment = gql`
  fragment SessionInfoFragment on SessionInfo {
    apiKey
    sessionId
    token
    isRecording
    archives {
      ...VirtualEventArchiveFragment
    }
  }
`;

export const VenueFragment = gql`
  fragment VenueFragment on EventVenue {
    type
    inPersonLocation {
      address {
        ...InPersonAddressFragment
      }
      description
    }
    online {
      ... on EventVenue_ExternalPlatform {
        additionalDetails
        externalPlatformName
        url
      }
      ... on EventVenue_TradewingPlatform {
        chatStreamChannelId
        agoraMeetId
        stream {
          ... on EventVenue_TradewingPlatform_Stream_Agora_Video_Call {
            agoraMeetSettings {
              maxParticipants
            }
          }
          
          ... on EventVenue_TradewingPlatform_Stream_Prerecorded {
            videoFile {
              _id
              hlsVideoStreamUrl
              s3DownloadUrl
              filename
            }
          }
          ... on EventVenue_TradewingPlatform_Stream_Live {
            virtualEvent {
              _id
              autoRecord
              canRecord
              dialInCode
              dialInEnabled
              dialInPhoneNumber
              listenerDialInCode
              numActiveAttendees
              maxParticipants
              sessionInfo {
                ...SessionInfoFragment
              }
            }
          }
        }
      }
    }
  }
  ${InPersonAddressFragment}
  ${SessionInfoFragment}
  ${VirtualEventArchiveFragment}
  ${VideoFileFragment}
`;
